import { getMoment } from "@libs/NwMoment";

export const getModelInTown = modelInTownSchedule => {
    const todayDate = getMoment(new Date());
    if (modelInTownSchedule && modelInTownSchedule.IsInTown && (todayDate >= getMoment(modelInTownSchedule.StartDate) && (todayDate <= getMoment(modelInTownSchedule.EndDate) || !modelInTownSchedule.EndDate))) {
        return true;
    } else {
        return false;
    }
};
